import { cn } from "@/shared/lib/utils";

export interface AmountBreakdownRow {
  key: string;
  label: string;
  value: string;
  total?: boolean;
}

export interface AmountBreakdownListProps {
  rows: AmountBreakdownRow[];
  /** Dims the figures while the next price arrives, so they do not blink on every keystroke. */
  loading?: boolean;
}

export function AmountBreakdownList({ rows, loading = false }: AmountBreakdownListProps) {
  return (
    <dl
      aria-busy={loading}
      className={cn(
        "rounded-xl border border-border bg-muted/30 px-4 py-3 transition-opacity motion-reduce:transition-none",
        loading && "opacity-60",
      )}
    >
      {rows.map((row) => (
        <div
          key={row.key}
          className={cn(
            "flex items-baseline justify-between gap-4 py-1.5",
            row.total && "mt-1.5 border-t border-dashed border-border pt-3",
          )}
        >
          <dt
            className={cn("text-sm", row.total ? "font-semibold text-foreground" : "text-muted-foreground")}
          >
            {row.label}
          </dt>
          <dd
            className={cn(
              "font-mono tabular-nums",
              row.total ? "text-lg font-bold text-foreground" : "text-sm font-medium text-foreground",
            )}
          >
            {row.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
